import { useState } from "react";

import { beautyFaqs } from "./beauty.constants";

export function BeautyFaq() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <section className="faq-sec" id="faq">
      <div className="faq-sticky">
        <div className="sec-kicker">Dúvidas</div>
        <h2 className="sec-h">Perguntas frequentes.</h2>
        <p className="sec-sub">Ainda com dúvida? Comece pelo caminho mais simples e fale com a gente se precisar.</p>
        <br />
        <a className="faq-start" href="/go/start">Começar 7 dias grátis -&gt;</a>
      </div>
      <div className="faq-list">
        {beautyFaqs.map((faq, index) => (
          <div key={faq.question} className={`faq-item${openFaq === index ? " open" : ""}`}>
            <button
              className="faq-q"
              type="button"
              onClick={() => setOpenFaq(openFaq === index ? -1 : index)}
              aria-expanded={openFaq === index}
            >
              {faq.question} <span className="faq-arrow">+</span>
            </button>
            <div className="faq-a">{faq.answer}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
